<div style="width: 100%; height: 100%; overflow: hidden">
  <list-view
    #listView
    [delegate]="gridDelegate"
    style="width: 100%; height: 100%; overflow: hidden"
  >
    <list-render-items>
      <div class="alert alert-danger" role="alert" *ngIf="errorMsg">
        <em class="material-icons">warning</em>
        <span class="sr-only">Error:</span> {{errorMsg}}
      </div>
      <div class="ng-star-inserted" style="width: 100%; height: calc(100vh - 160px); overflow: hidden">
        <ag-grid-angular
          #agGrid
          id="agGrid"
          [context]="context"
          [editType]="'fullRow'"
          class="ag-theme-balham"
          style="width: 100%; height: 100%"
          [headerHeight]="40"
          [columnDefs]="columnDefs"
          [defaultColDef]="defaultColDef"
          [suppressRowClickSelection]="true"
          [components]="components"
          [rowSelection]="'rowSelection'"
          (gridReady)="onGridReady($event)"
          [components]="frameworkComponents"
          [rowData]="listView.items"
          (rowValueChanged)="onRowValueChanged($event)"
          (cellValueChanged)="onCellValueChanged($event)"
        >
        </ag-grid-angular>
      </div>
    </list-render-items>
  </list-view>
</div>
